import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'upcoming-survey-answers');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'upcoming_assignments',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
    'new_answers',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/upcoming-survey-answers.js